<template>
  <div class="body-table">
          <table class="body-table-table">
            <tr class="body-table-table__tr">
              <th>部位</th>
              <th>度法</th>
              <th>+/-</th>
              <!-- <th>备注</th> -->
              <th
                v-for="(item, $index) in info.sizeCodeList"
                :key="`tab-description__${$index}`"
              >{{item|filterSizeName}}</th>
            </tr>
            <tr
              :key="`body-table__item-${$index}`"
              v-for="(item, $index) in info.sizeItemList"
              class="body-table-table__tr"
            >
              <td>{{item.usedPosition}}</td>
              <td>{{item.degreeMethod}}</td>
              <td>{{item.increaseOrDecrease}}</td>
              <!-- <td>{{item.remark}}</td> -->
              <td
                :key="`body-table__item__colors-${$index}`"
                v-for="(inner, $index) in info.sizeCodeList"
              >{{ item.sizeMap[inner.sizeName]}}</td>
            </tr>
          </table>
          <div class="body-table__foot">
            <div>复核：</div>
            <div>内检：</div>
            <div>打印日期：</div>
          </div>
        </div>
</template>

<script>
import { formatImgUrl } from "src/filter/modules/img";

export default {
  name: "print-size",
  filters: {
    formatImgUrl,
    formatCodeList(array, keys) {
      return array
        .reduce((pre, next) => {
          const index = keys.findIndex(inner => inner.colorCode == next);
          if (index > -1) pre.push(keys[index].colorName);
          return pre;
        }, [])
        .join(",");
    },
    filterSizeName(obj) {
      const { sizeCode, sizeName } = obj;
      const str = sizeName.match(/[a-zA-Z]+/);
      if (sizeCode == "pieceSize" || sizeCode == "codeSize") return sizeName;
      if (!str) return sizeName;
      return str[0];
    },
    formatString(str) {
      if (!str) return "";
      return str.replace(/\s*/g, "");
    }
  },
  props: {
    info: {
      type: Object,
      default: () => ({})
    },
    isWoollen: {
      type: Boolean,
      default: false
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "src/sass/index";
@import "src/sass/modules/mixin";
$_normal_font: 4mm;
$_title_font: 5mm;
$box_width: 190mm;
$box_height: 277mm;
$_black: #333;
.default_text_over {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 7;
  overflow: hidden;
}
.default_border {
  border-top: 1px solid $_black;
  border-left: 1px solid $_black;
}
.default_title {
  height: 6mm;
  text-align: center;
}
.default_table {
  width: 100%;
  td {
    border-collapse: collapse;
  }
  td,
  th {
    border: 1px solid $_black;
    border: 1px solid $_black;
  }
}
// 底部表格
.body-table {
  .body-table-table {
    @extend .default_table;
  }
  .body-table-table__tr {
    height: 5.2mm;
  }
}
.body-table__foot {
  height: 5mm;
  @include flex_center(space-around, center);
  border-left: 1px solid $_black;
  border-right: 1px solid $_black;
  border-bottom: 1px solid $_black;
}
</style>
